import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, TextStyled, HeadingStyled, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, HeroBg, HeroBgAr, Lights, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import ServiceMaintane from './ServiceAchive'
// import ServicesBlocks from './serviceContent/ServicesBlocks'
const Services = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <ServicesWapper className='container-fluid common-space servicesFluid' id="features">
                <Container>
                    <Box className='servicesRow row'>
                        
                        <Col md={12} className="servicesColBlocks">
                            <ServiceMaintane />
                        </Col>
                    </Box>
                </Container>
            </ServicesWapper>
        </>
    )
}
const ServicesWapper = styled.section`
    padding-bottom: 0;
    
    
    & > .container{
        .servicesRow{
            /* margin-left: 0;
            margin-right: 0; */
        }
        
        .servicesDescRow{
            position: relative;
            padding: 0px 32px 0 32px;
            flex-wrap: nowrap;
            margin-bottom: 20px;
        }
        .servicesDescRowInner{
            border-bottom: 1px solid rgba(236, 240, 253, .2);
            padding-bottom: 40px;
        }
        .servicesDescCol1{
            display: flex;
            justify-content: center;
            padding-right: 40px;
            max-width: 425px;
            min-width: 425px;
        }
        .servicesDescCol1Content{
            display: inline-block;
            max-width: 520px;
        }
        .servicesDescCol2{
            display: flex;
            width: calc(100% - 425px);
            /* justify-content: center; */
            /* padding-left: 200px; */
            .servicesDescCol2Content{
                display: inline-block;
                /* width: 320px; */
            }
        }
        
        
    }
    body.rtl &{
        & > .container{
            /* .servicesMH{
                font-size: 48px;
            } */
            .servicesIH{
                font-size: 28px
            }
            .servicesDescCol1{
                padding-right: calc(var(--bs-gutter-x) * .5);
                /* padding-left: 100px; */
            }
            /* .servicesDescCol2 {
                padding-left: 0;
                padding-right: 200px;
            }
            .servicesDescCol1Content {
                max-width: 490px;
            }
            .lights {
                left: 36%;
            } */
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            .servicesDescCol1{
                padding-right: calc(var(--bs-gutter-x) * .5);
            }
        }
        body.rtl &{
            & > .container{
                
                
            }
        }
    }
    @media (max-width: 1199px) {
        & > .container{
            
            
        }
        body.rtl &{
            & > .container{
                .lights {
                    left: 32%;
                }
                
            }
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .servicesDescCol{
                /* padding: 0; */
                
            }
            .servicesMH{
                font-size: 40px;
            }
            .servicesDescCol1Content {
                max-width: 100%;
            }
            .servicesDescCol1{
                justify-content: flex-start;
                margin-bottom: 10px;
            }
            .servicesDescCol2{
                .servicesDescCol2Content{
                    width: 100%;
                }
            } 
            .lights{
                display: none;
            }
            .serviceArchiveSec {
             padding-top: 30px
            }
        }
        body.rtl &{
            & > .container{
                .servicesDescCol1Content {
                    max-width: 100%;
                }
                .servicesDescCol2 {
                    padding-right: calc(var(--bs-gutter-x) * .5);
                    padding-left: calc(var(--bs-gutter-x) * .5);
                }
                .servicesMH{
                    font-size: 40px;
                }
                .servicesIH{
                    font-size: 24px;
                }
                .servicesDescCol1{
                    padding-right: calc(var(--bs-gutter-x) * .5);
                    padding-left: calc(var(--bs-gutter-x) * .5);
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .servicesMH{
                font-size: 35px;
            }
            .servicesIH{
                font-size: 24px;
            }
            .transformTxt{
                font-size: 18px;
            }
            
        }
        body.rtl &{
            & > .container{
                .servicesMH{
                    font-size: 28px;
                }
                .servicesIH{
                    font-size: 24px;
                }
                .transformTxt{
                    font-size: 18px;
                }
                
            }
        }
    }
    @media (max-width: 640px) {
    body.rtl &{
       & > .container{
            .servicesMH{
                font-size: 28px;
            }
           
            
        }
    }
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 350px) {
        
    }
`
export default Services
